import React, { useEffect, useState } from 'react';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';

/**
 * Schedule form: shows which JD and hiring-manager intake the interview questions will come
 * from, and warns when the JD text is missing, no intake exists, or the selected tech stack
 * isn't in the JD/intake. The JD + intake + tech stack define WHAT is tested; the resume only
 * personalises.
 */
export default function Phase3QuestionSourcesPreview({ requirementId, techStack, onSources }) {
  const [data, setData] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!requirementId) { setData(null); return undefined; }
    let cancelled = false;
    const timer = setTimeout(async () => {                 // debounce tech-stack edits
      try {
        const token = localStorage.getItem('token');
        const url = `${API_BASE}/api/phase3/requirement/${requirementId}/interview-sources`
          + `?tech_stack=${encodeURIComponent(techStack || '')}`;
        const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
        const json = await res.json();
        if (!cancelled) {
          setData(res.ok ? json.data : null); setFailed(!res.ok);
          if (res.ok && onSources) onSources(json.data);   // e.g. must-have technologies for the pre-fill
        }
      } catch (e) {
        if (!cancelled) { setData(null); setFailed(true); }
      }
    }, 400);
    return () => { cancelled = true; clearTimeout(timer); };
  }, [requirementId, techStack, onSources]);

  if (!requirementId || failed || !data) return null;
  const intake = data.intake || {};
  return (
    <div className="rounded-xl border border-gray-200 bg-gray-50 p-4 space-y-2" data-testid="question-sources">
      <p className="text-xs font-bold text-gray-500 uppercase tracking-wide">Questions will be based on</p>
      <p className="text-sm text-gray-700">
        {data.jd?.available ? '✅' : '⚠️'} <span className="font-semibold">Job description:</span>{' '}
        {data.jd?.available ? `${data.jd.filename || 'JD'} (${data.jd.chars.toLocaleString()} characters)` : 'text not available'}
      </p>
      <p className="text-sm text-gray-700">
        {intake.found ? '✅' : '⚠️'} <span className="font-semibold">Hiring-manager intake:</span>{' '}
        {intake.found
          ? `${intake.title || `Requirement ${intake.requirement_id}`}${intake.date ? ` — ${new Date(intake.date).toLocaleDateString()}` : ''} (${intake.how})`
          : 'none found for this JD'}
      </p>
      <p className="text-xs text-gray-500">The JD and intake decide what is tested; the candidate's resume decides where to probe and how deep — never what.</p>
      {(data.warnings || []).map((w) => (
        <p key={w.code} className="text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2"
           data-testid={`source-warning-${w.code}`}>
          ⚠️ {w.message}
        </p>
      ))}
    </div>
  );
}
